import React, { useState, useEffect } from 'react';
import { Grid, Button, Chip, Typography, Box } from '@mui/material';
import _ from 'lodash';
import { numberWithCommas } from 'utility';
import clsx from 'clsx';
import { FILTER_TYPES } from './services/Services';
import { useStyles } from './style';
import FilterPodModal from './FilterPodModal';
import { useForm } from 'react-hook-form';
import { CircularProgress } from '@mui/material';
import { FilterFieldsGenerator } from './FilterFieldsGenerator';
import { InfoBox, Icons } from 'components';
const FilterPod = ({
  isLoading = false,
  filters = [],
  onChange = () => {},
  onChangeFilterItem = () => {},
  onChangeTemp = () => {},
  hideSelect = false,
  forceShowChips = false,
  openFilterDialog,
  setOpenFilterDialog,
  handleCloseFilterDialog,
  isShowCustomRemoveBtn = false,
  clearAllFilters = () => {},
}) => {
  // -- STATES --//
  const [currentFilter, setCurrentFilter] = useState(filters[0] ?? null); // temp filter to save changes of current filter item
  const [localFilters, setLocalFilters] = useState(filters);
  const [searchedLocalFilters, setSearchedLocalFilters] = useState(filters);
  const [errorList, setErrorList] = useState([]);
  const { control } = useForm();
  // -- HOOKS --//
  const classes = useStyles();

  useEffect(() => {
    setLocalFilters(filters);
    setSearchedLocalFilters(filters);
  }, [filters]);

  useEffect(() => {
    setTimeout(() => {
      onChangeTemp(localFilters);
    }, 1);
  }, [localFilters]);
  useEffect(() => {
    setTimeout(() => {
      JSON.stringify(filters) !== JSON.stringify(localFilters) && onChangeFilterItem(localFilters);
    }, 1);
  }, [localFilters]);

  useEffect(() => {
    checkValidDateRange();
  }, [currentFilter]);
  // -- OTHER FUNCTIONS --//

  const onChangeActiveFilter = (filterKey) => {
    const newF = localFilters.find((v) => v?.keyName === filterKey);
    if (newF) {
      setCurrentFilter({ ...newF });
    }
  };
  const errorsToStr = (errs) => {
    if (!errs) return null;
    return (
      <div>
        {errs.map((v) => (
          <li
            style={{
              height: '20px',
              lineHeight: '20px',
              fontSize: '12px',
            }}
          >
            {v} را درست وارد کنید.{' '}
          </li>
        ))}
      </div>
    );
  };
  const pushFilter = async (newChangeFilter) => {
    const newFilter = newChangeFilter;
    let tempFilters = [...localFilters];
    let targetIndex = _.findIndex(tempFilters, (v) => v?.keyName === newFilter?.keyName);
    if (targetIndex >= 0) {
      tempFilters[targetIndex] = { ...newFilter };
      setLocalFilters(tempFilters);
      return tempFilters;
    }
    return null;
  };

  const submitAllFilters = async () => {
    setSearchedLocalFilters(localFilters);
    onChange(localFilters);
    setOpenFilterDialog(false);
  };

  const resetFilterItem = (keyName) => {
    const tempFilters = [...localFilters];
    const targetIndex = _.findIndex(tempFilters, (v) => v?.keyName === keyName);
    if (targetIndex >= 0) {
      tempFilters[targetIndex] = {
        ...tempFilters[targetIndex],
        value:
          tempFilters[targetIndex]?.value?.hasOwnProperty('start') &&
          tempFilters[targetIndex]?.value?.hasOwnProperty('end')
            ? {
                start: tempFilters[targetIndex]?.value?.resetValue?.start ?? null,
                end: tempFilters[targetIndex]?.value?.resetValue?.start ?? null,
              }
            : tempFilters[targetIndex]?.value?.resetValue ?? null,
      };
      setLocalFilters(tempFilters);
      setSearchedLocalFilters(tempFilters);
      onChange(tempFilters);
      checkValidDateRange();
    }
  };
  const deleteAllFilters = () => {
    let tempFilters = [...localFilters];

    tempFilters = tempFilters.map((v) => {
      if (!v?.disableDelete) {
        if (v?.value?.hasOwnProperty('start') && v?.value?.hasOwnProperty('end')) {
          return {
            ...v,
            value: {
              start: v?.value?.resetValue?.start ?? null,
              end: v?.value?.resetValue?.start ?? null,
            },
          };
        } else {
          return {
            ...v,
            value: v?.value?.resetValue ?? null,
          };
        }
      } else {
        return v;
      }
    });

    setLocalFilters(tempFilters);
    setSearchedLocalFilters(tempFilters);
    onChange(tempFilters);

    if (tempFilters.length > 0) {
      onChangeActiveFilter(tempFilters[0]?.keyName);
    }
    checkValidDateRange();
  };
  // -- LOCAL VARIABLES --//
  let hasActiveFilter = false;

  /**
   * چک میکنه تاریخ انتخاب شده درست هست یا خیر که پیغام خطا نمایش دهد
   */
  const checkValidDateRange = () => {
    let result = [];
    localFilters.forEach((fields) => {
      if (
        (fields && fields?.filterType == FILTER_TYPES.dateRange) ||
        (fields && fields?.filterType == FILTER_TYPES.dateTimeRange) ||
        fields.filterType === FILTER_TYPES.month
      ) {
        if (fields?.value?.start !== null && fields?.value?.end !== null) {
          if (
            new Date(getDateFromDateTime(fields?.value?.start)) -
              new Date(getDateFromDateTime(fields?.value?.end)) >
            0
          ) {
            let temp = fields?.title;
            result.push(temp);
          } else {
            let temp = fields?.title;
            let index = result.indexOf(temp);
            if (index !== -1) {
              result = result.splice(index, 1);
            }
          }
        }
      }
      if (fields && fields?.filterType == FILTER_TYPES.textRange) {
        if (parseInt(fields?.value?.end) < parseInt(fields?.value?.start)) {
          let temp = fields?.title;
          result.push(temp);
        } else {
          let temp = fields?.title;
          let index = result.indexOf(temp);
          if (index !== -1) {
            result = result.splice(index, 1);
          }
        }
      }
    });
    setErrorList(result);
  };
  /**
   * @param {تاریخ و ساعت} dt
   * تایم کامل میگیره و فقط قسمت تاریخ رو خروجی برمیگردونه
   */
  const getDateFromDateTime = (dt) => {
    if (currentFilter.filterType == FILTER_TYPES.dateTimeRange) {
      return new Date(dt);
    } else {
      return Intl.DateTimeFormat('en-US').format(new Date(dt));
    }
  };
  const ActionsBtn = () => {
    return (
      <Box className={classes.submit}>
        <Button variant="contained" onClick={handleCloseFilterDialog}>
          انصراف
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={submitAllFilters}
          disabled={errorList?.length > 0}
          startIcon={<Icons icon="Search" color="#fff" size="20" />}
          className={classes.submitButton}
        >
          جستجو
        </Button>
      </Box>
    );
  };

  return (
    <Grid className={classes.root}>
      <FilterPodModal open={openFilterDialog} actions={<ActionsBtn />}>
        {!isLoading && (
          <Grid container spacing={2}>
            {currentFilter ? (
              <>
                <FilterFieldsGenerator
                  localFilters={localFilters}
                  setCurrentFilter={setCurrentFilter}
                  pushFilter={pushFilter}
                  checkValidDateRange={checkValidDateRange}
                  control={control}
                />

                {/* برای نماش خطای محدوده تاریخ ، بررسی میکنم یه خطایی داشته باشد و تب جاری حتما مربوط به محدوده تاریخ باشد. */}

                {errorList && errorList?.length > 0 && (
                  <InfoBox title="خطای اعتبارسنجی" content={errorsToStr(errorList)} />
                )}
              </>
            ) : null}
          </Grid>
        )}
        {isLoading && (
          <Grid container style={{ minHeight: '280px', width: '100%' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <CircularProgress size={24} />
            </div>
          </Grid>
        )}
      </FilterPodModal>

      {!hideSelect || forceShowChips ? (
        <Grid container className={classes.chips}>
          {searchedLocalFilters?.map((v, k) => {
            if (k === 0) {
              hasActiveFilter = false;
            }
            if (getValueText(v)) {
              if (!v?.disableDelete) {
                hasActiveFilter = true;
              }
              return (
                <Chip
                  className={clsx(classes.chip, {
                    disableDelete: v?.disableDelete,
                  })}
                  key={k}
                  label={
                    <Typography style={{ fontSize: 12 }}>
                      <bdi className={classes.chipTitle}>{v?.title}:</bdi> {getValueText(v) ?? ''}
                    </Typography>
                  }
                  onClick={() => {
                    setOpenFilterDialog(true);
                    onChangeActiveFilter(v?.keyName);
                  }}
                  onDelete={!v?.disableDelete ? () => resetFilterItem(v?.keyName) : null}
                />
              );
            }
          })}

          {hasActiveFilter && searchedLocalFilters?.length !== 1 ? (
            <Chip
              className={classes.deleteAllChips}
              label={
                <Typography className={classes.deleteAllChipsText}>حذف همه فیلترها</Typography>
              }
              onClick={deleteAllFilters}
            />
          ) : null}
          {/* درصورتیکه بخواهیم به جای حذف کل فیلترها ، عملیاتس کاستوم ایجاد کنیم ، isShowCustomRemoveBtn بعنوان پراپز پاس داده خواهد شد */}
          {isShowCustomRemoveBtn && searchedLocalFilters?.length !== 1 ? (
            <Chip
              className={classes.deleteAllChips}
              label={
                <Typography className={classes.deleteAllChipsText}>حذف همه فیلترها</Typography>
              }
              onClick={() => {
                clearAllFilters([], 'clear');
              }}
            />
          ) : null}
        </Grid>
      ) : null}
    </Grid>
  );
};

export default FilterPod;

export const getValueText = (v) => {
  if (!v?.value || v?.value === null || v?.value === '') return null;
  if (v?.value?.hasOwnProperty('start') || v?.value?.hasOwnProperty('start')) {
    if (
      (v.value.start == null || v.value.start == '') &&
      (v.value.end == null || v.value.end == '')
    )
      return null;
    switch (v?.filterType) {
      case FILTER_TYPES.dateTimeRange:
        return `${v.value.start ? `از ${v.value.start?.format('jYYYY/jMM/jDD HH:mm')}` : ''} ${
          v.value.end ? `تا ${v.value.end?.format('jYYYY/jMM/jDD HH:mm')}` : ''
        } ${v?.unit ?? ''}`;

      case FILTER_TYPES.dateRange:
        return `${v.value.start ? `از ${v.value.start?.format('jYYYY/jMM/jDD')}` : ''} ${
          v.value.end ? `تا ${v.value.end?.format('jYYYY/jMM/jDD')}` : ''
        } ${v?.unit ?? ''}`;

      case FILTER_TYPES.timeRange:
        return `${v.value.start ? `از ${v.value.start?.format('HH:mm')}` : ''} ${
          v.value.end ? `تا ${v.value.end?.format('HH:mm')}` : ''
        } ${v?.unit ?? ''}`;
      case FILTER_TYPES.month:
        return `${v.value.start ? `از ${v.value.start?.format('jYYYY/jMM')}` : ''} ${
          v.value.end ? `تا ${v.value.end?.format('jYYYY/jMM')}` : ''
        }`.trim();

      case FILTER_TYPES.selectRange:
        const startTxt =
          v?.filterProps?.start?.options?.find((i) => i?.value === v?.value?.start)?.label ?? '';
        return `${startTxt?.length > 0 ? `از ${startTxt}` : ''}${
          v.value.end
            ? `تا ${v?.filterProps?.end?.options?.find((i) => i.value === v.value.end)?.label}`
            : ''
        } ${v?.unit ?? ''}`;

      default:
        const startTxt2 = v.value.start
          ? v?.addComma || v?.unit
            ? numberWithCommas(v.value.start)
            : v?.getValueLabel
            ? v?.getValueLabel(v.value.start)
            : v.value.start
          : '';

        const endText = v?.value?.end
          ? v?.addComma || v?.unit
            ? numberWithCommas(v.value.end)
            : v?.getValueLabel
            ? v?.getValueLabel(v.value.end)
            : v.value.end
          : '';
        if (v?.typeInput == 'string') {
          return `${startTxt2?.length > 0 ? ` ${startTxt2}` : ''}${
            endText ? '  ' : ''
          } ${endText} ${v?.unit ?? ''}`;
        } else {
          return `${startTxt2?.length > 0 ? `از ${startTxt2}` : ''}${
            endText ? ' تا' : ''
          } ${endText} ${v?.unit ?? ''}`;
        }
    }
  }

  switch (v?.filterType) {
    case FILTER_TYPES.dateTime:
      return `${v.value?.format('jYYYY/jMM/jDD HH:mm') ?? ''} ${v?.unit ?? ''}`;

    case FILTER_TYPES.date:
      return `${v.value?.format('jYYYY/jMM/jDD') ?? ''} ${v?.unit ?? ''}`;

    case FILTER_TYPES.year:
      return `${v.value?.format('jYYYY') ?? ''} ${v?.unit ?? ''}`;

    case FILTER_TYPES.time:
      return `${v.value?.format('HH:mm') ?? ''} ${v?.unit ?? ''}`;

    case FILTER_TYPES.select:
      return v?.filterProps?.options?.find((item) => item.value === v.value)?.label;

    default:
      return `${
        v.value
          ? v?.addComma
            ? numberWithCommas(v.value)
            : v?.getValueLabel
            ? v?.getValueLabel(v.value)
            : v.value
          : ''
      } ${v?.unit ?? ''}`;
  }
};
